import React from "react";
import useShopContext from "@hooks/useShopContext";
import { Stack } from "@mui/system";
import { IconButton } from "@mui/material";
import { ContactSupport } from "@mui/icons-material";
import { useRouter } from "next/router";
import { getUrlIcon } from "@common/utils/iconUtils";

const SocialLinks = () => {
  const router = useRouter();
  const { shop } = useShopContext();

  const links = shop?.shop_settings?.links || [];

  return (
    <Stack direction="row" justifyContent="center" alignItems="center">
      {links.map((link, index) => (
        <IconButton key={index} href={link} target="_blank" rel="noopener noreferrer" size="small">
          {getUrlIcon(link, "small")}
        </IconButton>
      ))}
      {shop?.shop_settings?.faqs?.length > 0 && (
        <IconButton key="FAQ" onClick={() => router.push("/faq")} size="small">
          <ContactSupport fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
};

export default SocialLinks;
